
<template>
  <span>

    <a href="#" class="btn btn-link p-0 mb-1" @click="doopen" style="color:inherit;"><i class="icon-qrcode"></i></a>

    <modal-in-front v-bind:title="map" ref="thisModal" size="modal-xs">
      <div style="margin:auto;overflow:visible;position:relative">
        <div class="container-fluid">
          <div class="row">
            <div class="col-12">
             <img width="100%" v-bind:src="url" />
            </div>
          </div>
          <div class="row">
            <div class="col-12 mt-3">
              <button type="button" @click="copyImage" class="btn btn-light col-12"><i class="icon-link mt-1 pull-left"></i>{{$t('copy_image_only')}}</button>
            </div>
            <div class="col-12 mt-1">
              <button type="button" @click="copyCard" class="testCopy btn btn-light col-12"><i class="icon-link mt-1 pull-left"></i>{{$t('copy_qr_code_card')}}</button>
            </div>
            <div class="col-12 mt-1 text-center custom-form-label" v-show="confirmCopy == true">
              <label class="custom-form-label">{{$t('copied_to_clipboard')}}</label>
            </div>
          </div>
        </div>
      </div>
    </modal-in-front>
  </span>

</template>

<script>

  import ModalInFront from "../modals/modal-in-front.vue";
  
  export default {
    name: 'qr-invite-button',
    components: {
      ModalInFront
    },
    props: {
      teamid: {
        required: false,
        type: String,
        default: null
      },
      lang: {
        required: false,
        type: String,
        default: null
      },
    },
    data() {
      return {
        url: '',
        confirmCopy:false
      }
    },
    methods: {
     
      getId() {
        return this._uid;
      },

      

      copyCard() {
        const el = document.createElement('textarea');
        el.value = "<table style='padding:10px;background-color:white;font-family:arial;border: 1px solid #c7c7c7'><tr><td style='font-size:1.5em; text-align:center;'><b>Some title</b></td></tr><tr><td><img width='180' src='" + this.url + "' /></td></tr><tr><td style='font-size:1em'>Some description</td></tr></table>";
        el.setAttribute('readonly', '');
        el.style.position = 'absolute';
        el.style.left = '-9999px';
        document.body.appendChild(el);
        const selected = document.getSelection().rangeCount > 0 ? document.getSelection().getRangeAt(0) : false;
        el.select();

        function listener(e) {
          e.clipboardData.setData("text/html", el.value);
          //e.clipboardData.setData("text/plain", el.value);
          e.preventDefault();
        }
        document.addEventListener("copy", listener);
        document.execCommand("copy");
        document.removeEventListener("copy", listener);

        //document.execCommand('copy');
        document.body.removeChild(el);
        if (selected) {
          document.getSelection().removeAllRanges();
          document.getSelection().addRange(selected);
        }
        this.confirmCopy = true;
        this.$forceUpdate();
      },

      copyImage() {
        const el = document.createElement('textarea');
        el.value = this.url;
        el.setAttribute('readonly', '');
        el.style.position = 'absolute';
        el.style.left = '-9999px';
        document.body.appendChild(el);
        const selected = document.getSelection().rangeCount > 0 ? document.getSelection().getRangeAt(0) : false;
        el.select();

        function listener(e) {
          e.clipboardData.setData("text/html", el.value);
          e.clipboardData.setData("text/plain", el.value);
          e.preventDefault();
        }
        document.addEventListener("copy", listener);
        document.execCommand("copy");
        document.removeEventListener("copy", listener);

        //document.execCommand('copy');
        document.body.removeChild(el);
        if (selected) {
          document.getSelection().removeAllRanges();
          document.getSelection().addRange(selected);
        }
        this.confirmCopy = true;
        this.$forceUpdate();
      },
      
      doopen() {
        this.setInviteQRcodeUrl();
        this.$refs.thisModal.open();
      },

      setInviteQRcodeUrl() {

        var imageurl = apiUrl + "/api/Procedures/v1/GetInviteQRCode?";

        if (this.teamId != null) {
          imageurl += "&teamid=" + this.teamId
        }
        if (this.lang != null) {
          imageurl += "&lang=" + this.lang
        }

        this.url = imageurl;
        this.$forceUpdate();
       
      },
      
    },
    created() {

    },
    mounted() {
     
    }
  }
</script>



<style scoped>
  .btn-outline-grey {
    color: #aaa;
    border-color: #aaa;
  }
  .btn-outline-grey:not(:disabled):not(.disabled).active, .btn-outline-grey:not(:disabled):not(.disabled):active, .show > .btn-outline-grey {
    color: #fff;
    background-color: #aaa;
    border-color: #aaa;
  }
</style>



// WEBPACK FOOTER //
// src/components/qrcode/qr-invite-button.vue